<template lang="pug">
    #app(:class="{'not-ready': notReady}")
        Header#top
        #middle
            .sidebar-toggle(@click="toggleSidebar" :class="toggleClass") {{ toggleText }}
            #sidebar(:class="{ 'sidebar-active': sidebarOpen }")
                Welcome
                AddressSearch(id="geocoder")
                BoundarySelector.only-screen
                div(v-if="yearGroup && yearGroup !== 'specialist'")
                    .small-text A child has the right to attend their local (zoned) school. Families can also apply to a school that is not their local school.
                    br

                    .small-text If the zone line intersects the block of land containing your residence, then your child has a right to attend either school.
                    br
                    .small-text For more information, see: 
                        a(href="https://www.vic.gov.au/school-zones" target="_blank") School zones
                        | and 
                        a(href="https://www.vic.gov.au/how-choose-school-and-enrol" target="_blank") Enrol in school
                        |.
                div(v-if="yearGroup==='specialist'")
                    .small-text A child, including a child with a disability, has the right to attend their local (zoned) school. Families can also apply to a school that is not their local school.
                    br
                    .small-text.only-screen For more information about access to education for children with disability, including the adjustments the school must make, see 
                        a(href="https://www.vic.gov.au/disability-rights-and-responsibilities-schools" target="_blank") Rights and Responsibilities
                        |, 
                        a(href="https://www.vic.gov.au/school-zones" target="_blank") School zones
                        |, 
                        a(href="https://www.vic.gov.au/how-choose-school-and-enrol" target="_blank") Enrol in school
                        | and 
                        a(href="https://www.vic.gov.au/getting-to-from-school-students-disability" target="_blank") Getting to school
                        |.

                    //- .small-text All students, including students with disabilities, have the right to be enrolled in their designated neighbourhood Government school. All schools must make reasonable adjustments to accommodate students with disabilities to assist them to participate in their education on the same basis as their peers without disabilities. see:
                    //-   |  <a href="https://www.vic.gov.au/disability-rights-and-responsibilities-schools" target="_blank">Rights and Responsibilities.</a>
                    //- p.small-text For more information about specialist school enrolment and transport support, see:
                    //-   |  <a href="https://www.vic.gov.au/school-zones" target="_blank">School Zones</a>,
                    //-   |  <a href="https://www.vic.gov.au/how-choose-school-and-enrol" target="_blank">Enrol in school</a> and
                    //-   |  <a href="https://www.vic.gov.au/getting-to-from-school-students-disability" target="_blank">Getting to school</a>.
                SchoolSearch(v-show="hasBoundarySet")
                Results
                //- div(v-if="yearGroup==='primary' || yearGroup === 'secondary'")
                //-     .small-text If the zone line intersects the block of land containing your residence, then your child has a right to attend either school.
                //-     p.small-text.only-screen For more information, see: <a href="https://www.vic.gov.au/school-zones" target="_blank">School Zones</a> and <a href="https://www.vic.gov.au/how-choose-school-and-enrol" target="_blank">Enrol in school</a>

            #map-container
                #another-container
                    Map(@schoolSelected="showSidebar" @mapLoaded="loadHash")

        #bottom(:class="{ 'footer-active': footerOpen }")
            .footer-toggle.only-screen(@click="closeFooter") Close
            Footer
</template>

<script>
import './initConstants';
import Map from './components/Map.vue';
import SchoolSearch from './components/SchoolSearch.vue';
import AddressSearch from './components/AddressSearch.vue';
import BoundarySelector from './components/BoundarySelector.vue';
import Welcome from './components/Welcome.vue';
import Footer from './components/Footer.vue';
import Header from './components/Header.vue';
import Results from '@/components/Results.vue';
import { EventBus } from './components/EventBus';

window.track = function (...args) {
    if (
        (!window.location.host.match(/localhost/) &&
            !window.location.hash.match(/notrack/)) ||
        window.location.hash.match(/dotrack/)
    ) {
        window.ga('send', 'event', ...args);
        window.ga('det.send', 'event', ...args);
    }
};

window.app.showBasemap =
    window.app.env === 'prod' || window.location.hash.match('map');

window.app.tileHost = '';
window.app.lookupHost = '';
if (
    window.location.hash.match('tilesqa') ||
    window.location.hostname.match(/-qa/)
) {
    window.app.tileHost =
        window.location.protocol + '//schoolboundaries-qa.crowdspot.com.au';
    window.app.lookupHost = window.app.tileHost;
} else if (window.location.host.match('localhost')) {
    window.app.tileHost = 'http://localhost:4001';
    window.app.lookupHost = 'http://localhost:4008';
}

export default {
    name: 'app',
    components: {
        Map,
        SchoolSearch,
        AddressSearch,
        BoundarySelector,
        Welcome,
        Footer,
        Header,
        Welcome,
        Results,
    },
    data: () => ({
        hasBoundarySet: false,
        welcomeClosed: false,
        sidebarOpen: true,
        footerOpen:
            JSON.parse(window.localStorage.getItem('footerOpen')) || true,
        notReady: true,
        yearGroup: undefined,
        hashLoaded: false,
    }),
    created() {
        window.app.App = this;
        EventBus.$on('boundarySetChanged', this.boundarySetChanged);
        EventBus.$on('school-select', () => (window.app.Welcome.show = false)); // is this still used?
        EventBus.$on('boundaries-results', async () => {
            await this.$nextTick();
            document.getElementById('Results').scrollIntoView(true);
            window.setTimeout(() => {
                document.getElementById('Results').scrollIntoView(true);
            }, 500);
        });
    },
    methods: {
        toggleSidebar() {
            this.sidebarOpen = !this.sidebarOpen;
            window.track(
                'App',
                'sidebaropen',
                this.sidebarOpen ? 'open' : 'close'
            );
        },
        showSidebar() {
            this.sidebarOpen = true;
        },
        closeFooter() {
            this.footerOpen = false;
            window.localStorage.setItem('footerOpen', 'false');
            window.track('App', 'closefooter');
        },
        boundarySetChanged(boundaryset, boundarySelector) {
            this.yearGroup = boundarySelector.selectedYearGroup;
        },
        async loadHash() {
            await window.app.schoolsLoading;
            const [, schoolEntityCode] =
                window.location.hash.match(/school=(\d+)/) || [];
            if (schoolEntityCode) {
                const school = window.app
                    .currentSchools()
                    .features.find(
                        (f) => f.properties.Entity_Code == schoolEntityCode
                    );
                window.app.BoundarySelector.findBoundarySetForSchool(school);
                EventBus.$emit('school-select', school, 'jump');
            }
            this.hashLoaded = true;
        },
        hasSchool() {
            return !!(
                window.app.SchoolInfo && window.app.SchoolInfo.selectedSchool
            );
        },
    },
    computed: {
        toggleText() {
            if (this.sidebarOpen) {
                return 'View map';
            } else {
                return 'View details';
            }
        },
        toggleClass() {
            if (this.sidebarOpen) {
                return 'sidebar-toggle-active';
            } else {
                return '';
            }
        },
    },
};
</script>

<style>
html,
body {
    height: 100vh;
    width: 100%;
    margin: 0;
    padding: 0;
}

@font-face {
    font-family: VIC;
    src: url('/fonts/VIC_FONT/VIC/VIC-SemiBold.otf') format('opentype');
    font-weight: bold;
    font-style: normal;
    /* font-weight-normal;*/
    /* url("/fonts/VIC_FONT/VIC/VIC-Light.otf") format("opentype") font-weight-bold; */
}

@font-face {
    font-family: VIC;
    src: url('/fonts/VIC_FONT/VIC/VIC-Regular.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: VIC;
    src: url('/fonts/VIC_FONT/VIC/VIC-Light.otf') format('opentype');
    font-weight: 100;
    /* font-style: ; */
}

#app {
    font-family: 'VIC', 'Avenir', Helvetica, Arial, sans-serif;
    font-weight: normal;
    display: flex;
    flex-direction: column;
    height: 100vh;
}
#app * {
    transition: opacity 0.3s;
}

#top {
    /* flex-basis: 60px; */
    border-bottom: 1px solid #d3d3d3;
}

#middle {
    position: relative;
    flex-grow: 1;
    min-height: 0; /* Crucial to making overflow scroll work */
    display: flex;
}
@media print {
    #middle {
        flex-direction: column;
    }
}

.sidebar-toggle {
    display: none;
    z-index: 11;
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px 10px;
    font-size: 14px;
    border-radius: 3px;
    box-shadow: 0 0 2px black;
    cursor: pointer;
    color: black;
    background: white;
}

#sidebar {
}

@media screen and (max-width: 767px) {
    .sidebar-toggle {
        display: block;
    }
    #sidebar {
        position: absolute;
        left: 0;
        right: 0;
        z-index: 10;
        background: white;
        overflow: auto;
        display: none;
        min-height: 400px;
        padding-bottom: 8em;
    }
    #sidebar.sidebar-active {
        display: block;
    }
}

@media screen and (min-width: 768px) {
    #sidebar {
        flex-basis: 300px; /* Horizontally */
        border-right: 1px solid lightgrey;
        overflow: auto;
        height: calc(100vh - 87px);
    }
}

@media screen {
    #sidebar > div {
        padding: 0 1em 1em;
    }
}

#map-container {
    flex-grow: 1;
    position: relative;
}

@media screen and (min-width: 768px) {
    #map-container {
        flex-basis: 400px;
        position: relative;
    }
}

#another-container {
    height: 100%;
    position: relative;
}

.footer-toggle {
    position: absolute;
    top: -9px;
    right: 10px;
    background: white;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 2px black;
    font-size: 10px;
    padding: 1px 5px;
    cursor: pointer;
}

#bottom {
    position: relative;
    /* height: 6em; */
    border-top: 1px solid lightgrey;
    border-left: 1px solid lightgray;
    background: white;
}

#Footer {
    font-size: 10px;
}

@media screen and (max-width: 767px) {
    #bottom {
        display: none;
        position: fixed;
        bottom: 0;
        z-index: 10;
    }
    #bottom.footer-active {
        display: block;
    }
}

@media screen and (min-width: 768px) {
    .footer-toggle {
        display: none;
    }
    #bottom {
        overflow: initial;
        height: auto;
        margin-left: 300px;
    }
    .only-mobile {
        display: none;
    }
}

h2 {
    margin-top: 0.5em;
}

.not-ready label,
.not-ready input,
.not-ready .btn {
    color: grey !important;
    pointer-events: none;
}

@media print {
    .only-screen {
        display: none;
    }
}

@media screen {
    .only-print {
        display: none;
    }
}

.small-text {
    font-size: 0.75em;
}
.fine-print {
    font-size: 14px;
    margin-top: 8px;
    color: #555;
    line-height: 0.85;
    font-weight: 100;
}
</style>
